import { useQuery } from '@tanstack/react-query';

import { adminsApi } from '@/lib/api';

import { queryKeys } from './query-keys';

/**
 * The admin-management roster: admins (active or suspended) + not-yet-accepted
 * invitations, read live from GET /admins. Drives both tables in the Admins
 * settings section. The lifecycle mutations (resend/revoke/suspend/activate)
 * refetch this query on success so the tables always reflect server truth
 * (TDEV-140).
 */
export function useAdminRosterQuery() {
  return useQuery({
    queryKey: queryKeys.admins.roster,
    queryFn: ({ signal }) => adminsApi.getRoster(signal),
  });
}
